import { mergeStyles } from "@uifabric/merge-styles"

const style = mergeStyles({
    width: 900,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    '@media(max-width: 900px)': {
        width: '100%',
        padding: 8,
        boxSizing: 'border-box',
    },
    '@media(max-height: 1250px)': {
        position: 'static',
        transform: 'none',
        marginTop: 24,
        marginBottom: 48,
    }
})

export const Content = ({children} : {children: JSX.Element | JSX.Element[]}) => (
    <div className={style}>
        {children}
    </div>
)